import { render, staticRenderFns } from "./LoginOverLay.vue?vue&type=template&id=2afa34ab&scoped=true"
import script from "./LoginOverLay.vue?vue&type=script&lang=js"
export * from "./LoginOverLay.vue?vue&type=script&lang=js"
import style0 from "./LoginOverLay.vue?vue&type=style&index=0&id=2afa34ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afa34ab",
  null
  
)

export default component.exports